import { NgModule } from '@angular/core';
import { MatAutocompleteModule, MatButtonModule, MatDatepickerModule, MatDialogModule, MatIconModule, MatInputModule, MatSelectModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { ScheduleSuggestionsModule } from '../../components/schedule-suggestions/schedule-suggestions.module';
import { DialogReopenMaintenanceComponent } from './dialog-reopen-maintenance.component';

@NgModule({
  entryComponents: [
    DialogReopenMaintenanceComponent
  ],
  declarations: [
    DialogReopenMaintenanceComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,

    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    NgxMaskModule.forRoot(),


    SegmentsModule,
    ScheduleSuggestionsModule
  ],
  exports: [
    DialogReopenMaintenanceComponent
  ]
})
export class DialogReopenMaintenanceModule { }
